import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'
import PropTypes from 'prop-types'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { TASK_VIEW_STATUSES } from '../../tasks/constants'
import { DEFAULT_PAGE } from '../constants'

const TaskViewStatusFilter = ({ disabled }) => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { viewStatus } = getQueryParams(search)

  const handleChange = useCallback(
    viewStatus =>
      history.push(
        createUrl(pathname, search, {
          viewStatus,
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Current view status">
      <Select
        style={{ width: '100%' }}
        value={viewStatus}
        onChange={handleChange}
        disabled={disabled}
        allowClear
      >
        {map(TASK_VIEW_STATUSES, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

TaskViewStatusFilter.propTypes = {
  disabled: PropTypes.bool,
}

TaskViewStatusFilter.defaultProps = {
  disabled: false,
}

export default TaskViewStatusFilter
